import type { CreateBusyBlockRequest, DeleteBusyBlockRequest } from "@planerius/contracts/cabinet"

import { apiRequest } from "./http"

/**
 * Занятость, которую заводит человек: перерыв, блокировка, отпуск.
 *
 * До этого файла у кабинета не было клиента /cabinet/busy вовсе: ни «Перерыва» мастера
 * (5-М5), ни «Заблокировать время» администратора (5-А3) сделать было нечем, хотя
 * маршруты существовали. Границы проверяет сервер: мастер ставит себе только перерыв,
 * только впереди и только внутри смены — экран лишь заранее подсказывает, где можно.
 *
 * Ключ идемпотентности приходит сверху по той же причине, что в journal-actions.api.ts:
 * он обязан пережить повтор нажатия, иначе потерянный ответ даёт второй перерыв.
 */

/** Закрыть время. 201, ответ — идентификатор новой строки занятости. */
export function createBusyBlock(
  request: CreateBusyBlockRequest,
  idempotencyKey: string,
): Promise<{ readonly id: string }> {
  return apiRequest<{ readonly id: string }>("/cabinet/busy", {
    method: "POST",
    body: request,
    idempotencyKey,
  })
}

/**
 * Снять занятость. С версией: иначе перерыв, который кто-то только что подвинул,
 * исчезнет молча — «последний победил».
 */
export function deleteBusyBlock(
  request: DeleteBusyBlockRequest,
  idempotencyKey: string,
): Promise<void> {
  return apiRequest<void>(`/cabinet/busy/${request.busyId}`, {
    method: "DELETE",
    body: request,
    idempotencyKey,
  })
}
